import fetcher from './fetchers'

export const fetchCodeToToken = (params) => {
  return fetcher.post('/v1/user/code_to_token', params)
}

export const fetchUserInfo = (params) => {
  return fetcher.post('/v1/user/info', params)
}

export const fetchShareAuth = (params) => {
  return fetcher.post('/v1/payment/jsapi/config', params)
}
